<template>
    <div class="card px-3 py-5 rounded sustainable-component common-label-container" style="display:block;position:relative" v-bind:id="'customModal' + getId()">
        <div class="tab-container rounded">
            <div class="px-3 pt-1 rounded tab-contained" style="">{{title}}</div>
        </div>
        <div>
            <slot>
                <div>Loading</div>
            </slot>
        </div>
    </div>
</template>


<script>

    import { getCurrentInstance } from 'vue'

    export default {
        inheritAttrs: true,
        emits: [],
        name: 'CommonLabelContainer',
        props: {
            title: {
                type: String,
                default: "",
                required: false,
            }
        },
        components:{
            
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
        },

        data() {
            return {
               
            };
        },
        watch: {
            
        },
        mounted() {
            
        },
        // eslint-disable-next-line
        setup(props, { emit }) {
            return { }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .tab-container {
        background: linear-gradient(180deg,#dfdfdf 61%,#fff 0);
        padding-left: 1px;
        padding-right: 1px;
        padding-top: 1px;
        display: inline-table;
        top: -14px;
        position: absolute;
        top: -18px;
    }

    .tab-contained {
        position:relative;
        color: rgba(0,0,0,0.6);
        background-color:white;
        font-size:16px;
        
    }
    

</style>
